<template>
	<div class="section-container">
		<div class="d-flex mb-4 section-title-container wrap txt-center align-center">
			<billing-buy-car-svg />
			<h2
				class="uppercase bold section-title"
				:style="`color:${globalColors.primary}`"
			>Facturación</h2>
		</div>
		<p class="mx-1">Activa esta opción para solicitar factura. No aplican productos que indicaban &quot;No se emite factura&quot;.</p>
		<p class="bold mx-1">Estimado cliente, recuerda que solamente recibirás factura sobre compras realizadas a Que Tal Compra o a sellers obligados a facturar. Gracias!</p>
		<el-switch
			class="my-3 mx-1"
			:active-text="labelByCountry"
			:active-color="activeColor"
			v-model="activeBilling"
			@input="changeActiveBill"
		>
		</el-switch>
		<form
			v-if="activeBilling"
			class="d-flex wrap"
		>
			<div class="content-type-document flex-45 mx-1 mb-1">
				<select-component
					v-if="isEcuador"
					class="select-component"
					placeholder="Tipo de Documento"
					item-text="name"
					item-value="code"
					:options="typeDocuments"
					v-model="billing.documentType"
				/>
			</div>
			<div prop="ruc" class="flex-45 mx-1 mb-1">
				<el-input
					class="qtc-input"
					v-model="billing.ruc"
					placeholder="Número de Documento"
					:style="`background-color:${globalColors.border}`"
					@input="checkingFalgValidDocumentNumber"
					@blur="onBlur"
				></el-input>
				<span class="error-message" v-if="$v.flagValidDocumentNumber.$invalid && $v.billing.ruc.required">Documento {{ rucWordByCountry }}</span>
				<span class="error-message" v-if="$v.billing.ruc.$invalid">Documento requerido.</span>
			</div>
			<div prop="rzSocial" class="flex-45 mx-1 mb-1">
				<el-input
					class="qtc-input"
					v-model="billing.rzSocial"
					:placeholder="rzSocialLabel"
					:style="`background-color:${globalColors.border}`"
					@input="validateForm"
				></el-input>
				<span class="error-message" v-if="!$v.billing.rzSocial.required">La razón social es requerida</span>
			</div>
			<div prop="address" class="flex-95 mx-1 mb-1">
				<el-input
					class="qtc-input"
					v-model="billing.address"
					placeholder="Dirección del domicilio fiscal"
					:style="`background-color:${globalColors.border}`"
					@input="validateForm"
				></el-input>
				<span class="error-message" v-if="!$v.billing.address.required">La dirección es requerida</span>
			</div>
		</form>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import selectComponent from '@/components/selectComponent';
import billingBuyCarSvg from '@/components/svg-components/billingBuyCar';

const greenSwitch = process.env.GREEN;

function mounted() {
	this.$store.commit('SET_FLAG_BILLING_DATA', this.activeBilling);
	if (this.orderSummaryInfo && this.orderSummaryInfo.dataBill) {
		const { address, ruc, rzSocial } = this.orderSummaryInfo.dataBill;
		this.billing = { address, ruc, rzSocial };
		this.changeActiveBill(true);
		this.validateForm();
	}
}

function activeColor() {
	return greenSwitch;
}

function validateForm() {
	this.$store.commit('SET_BILLING_DATA', null);
	if (!this.$v.$invalid) {
		const { documentType, ...billing } = this.billing;
		this.$store.commit('SET_BILLING_DATA', billing);
	}
}

function labelByCountry() {
	return this.isEcuador ? 'Factura a terceros' : 'Solicitar Factura';
}

function rzSocialLabel() {
	return this.isEcuador ? 'Nombre o Razón Social' : 'Razón Social';
}

function rucWordByCountry() {
	return this.isPeru ? 'requerido' : 'inválido';
}

function checkingFalgValidDocumentNumber() {
	this.flagValidDocumentNumber = !!this.billing.ruc;
}

function onBlur({ target }) {
	const val = target.value;
	this.billing.ruc = val;
	if (this.isEcuador && this.flagBillingValidate && val) {
		this.validatingDocumentNumber(val);
	}
}

async function validatingDocumentNumber(val) {
	this.$message({
		message: 'Validando Documento.',
		type: 'info',
	});
	const countryCode = this.getLocalStorage('country-code');
	const url = `${this.billing.documentType}/${val}?codeCountry=${countryCode}`;
	try {
		const { data: res } = await this.$httpDocumentNumberValidating.get(url);
		this.billing.address = res.data.domicilio;
		this.billing.rzSocial = res.data.nombre || res.data.Nombre_completo;
		this.$message({
			message: 'Validación exitosa',
			type: 'success',
		});
		this.flagValidDocumentNumber = true;
	} catch (error) {
		this.billing.address = '';
		this.billing.rzSocial = '';
		this.$message({
			message: 'No fue posible validar el documento. Intente con otro.',
			type: 'error',
		});
		this.flagValidDocumentNumber = false;
	}
}

function flagBillingValidate() {
	return this.getCommerceData.settings.flagBillingValidate;
}

function validations() {
	if (this.isPeru) {
		const billing = {
			address: { required },
			ruc: { required },
			rzSocial: { required },
		};
		return { billing };
	}
	return {
		billing: {
			address: { required },
			ruc: { required },
			rzSocial: { required },
		},
		flagValidDocumentNumber: {
			valid: v => !!v,
		},
	};
}

function handlerValidations() {
	this.validateForm();
}

function changeActiveBill(flagBill) {
	this.$store.commit('SET_FLAG_BILLING_DATA', flagBill);
	if (!flagBill) {
		this.$store.commit('SET_BILLING_DATA', null);
		this.billing = {
			address: '',
			rzSocial: '',
			ruc: '',
		};
	}
}

function data() {
	return {
		activeBilling: false,
		billing: {
			address: '',
			rzSocial: '',
			documentType: 'ruc',
			ruc: '',
		},
		flagValidDocumentNumber: true,
		typeDocuments: [
			{ name: 'CÉDULA', code: 'dni' },
			{ name: 'RUC', code: 'ruc' },
		],
	};
}

export default {
	name: 'billing',
	components: {
		billingBuyCarSvg,
		selectComponent,
	},
	computed: {
		...mapGetters([
			'billingData',
			'getCommerceData',
			'orderSummaryInfo',
		]),
		flagBillingValidate,
		activeColor,
		labelByCountry,
		rzSocialLabel,
		rucWordByCountry,
	},
	mounted,
	data,
	methods: {
		checkingFalgValidDocumentNumber,
		changeActiveBill,
		handlerValidations,
		onBlur,
		validatingDocumentNumber,
		validateForm,
	},
	validations,
	watch: {
		'$v.$invalid': handlerValidations,
	},
};
</script>
<style lang="scss" scoped>
	.section-container {

		p {
			font-size: size(medium) !important;

			@media (max-width: 500px) {
				text-align: center;
			}
		}
	}

	.select-component {
		background-color: rgb(228, 228, 228);
	}
</style>



// WEBPACK FOOTER //
// billing.vue?15b55dd2